import React from "react";
import PropTypes from "prop-types";
import { useStaticQuery, graphql } from "gatsby";
import "./layout.css";
import {
  Grommet,
  Box,
  ThemeContext,
  ResponsiveContext,
  Footer,
  Text,
} from "grommet";
import { grommet } from "grommet/themes";
import { withTrans } from "../../i18n/withTrans";
import { isPhone } from "../../services/utils";

const Layout = ({ children }) => {

  return (
    <Grommet
      theme={grommet}
      style={{
        display: "flex",
        flexDirection: "column",
      }}
    >
      <ThemeContext.Extend
        value={{
          global: { colors: { brand: "#E92C70" } },
          rangeInput: {
            track: {
              height: "10px",
              lower: {
                color: "#59A4F4",
                opacity: 0.7,
              },
              upper: {
                color: "dark-4",
                opacity: 0.3,
              },
            },
            thumb: {
              color: "#fff",
            },
          },
        }}
      >
        <ResponsiveContext.Consumer>
          {(size) => (
            <Box full="vertical" style={{ height: '100%', minHeight: '100vh' }}>

              <Box
                as="main"
                flex
                align="center"
                overflow="auto"
                style={{ alignItems: "stretch", marginBottom: 10 }}
              >
                {children}
              </Box>

              <Box style={{ height: 150 }} />
              {!isPhone(size) &&
                <Footer
                  background="light-4"
                  justify="center"
                  pad="small"
                  style={{ position: "fixed", bottom: 0 }}
                  float={true}
                  fixed={true}
                >
                  <Text textAlign="center" size="xsmall">
                    Trustiway Assurance est une Société par Actions Simplifiée
                    (SAS), au capital de 10 000€ et est inscrite au registre du
                    commerce et des sociétés de Paris sous le numéro 882 698 640
                    00019. Opérant sous la marque Trustiway, la société est
                    régie par le Code des Assurances et est immatriculée au
                    Registre ORIAS, sous le numéro 20003367. © Copyright 2020 –
                    Mentions légales – Une création de TRUSTIWAY GROUP
                  </Text>
                </Footer>
              }
            </Box>
          )}
        </ResponsiveContext.Consumer>
      </ThemeContext.Extend>
    </Grommet>
  );
};

Layout.propTypes = {
  children: PropTypes.node.isRequired,
};

export default Layout;
